import Image from "next/image";
import React from "react";
import CloseIcon from "@heroicons/react/solid/XIcon";

interface HeaderProps {
  image?: string;
  title: string;
  children?: React.ReactNode;
  onClose?: () => void;
}

const Header: React.FC<HeaderProps> = ({ children, title, image, onClose }) => {
  return (
    <div className="relative h-36 p-4 space-y-4 w-full flex flex-col justify-end">
      <div className="absolute inset-0 print:hidden">
        <Image
          className="w-full h-full object-cover"
          layout="fill"
          src={image || "/lent-main.jpeg"}
          alt=""
        />
        <div
          className="absolute inset-0 bg-accent mix-blend-multiply"
          aria-hidden="true"
        />
      </div>
      <h1>{title}</h1>
      {children}
      {onClose ? (
        <CloseIcon
          className="text-white w-6 h-6 sm:h-8 sm:w-8 absolute top-0 right-4 print:hidden"
          onClick={onClose}
        />
      ) : null}
    </div>
  );
};

export default Header;
